import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSalaryExternalEmployeeSalaryBillListDataApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSalaryExternalEmployeeSalaryBillListDataApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/exportByPage',
    method: 'post',
    data
  })
}

// 保存
export function saveSalaryExternalEmployeeSalaryBillApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/save',
    method: 'post',
    data
  })
}

// 作废
export function deleteSalaryExternalEmployeeSalaryBillApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/delete',
    method: 'post',
    data
  })
}

// 发布
export function publishSalaryExternalEmployeeSalaryBillApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/publish',
    method: 'post',
    data
  })
}

// 撤回
export function backSalaryExternalEmployeeSalaryBillApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/back',
    method: 'post',
    data
  })
}

// 查看
export function viewSalaryExternalEmployeeSalaryBillApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/view',
    method: 'post',
    data
  })
}

// 根据主键查询人员统计
export function findSummaryInfoByIdApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/findSummaryInfoById',
    method: 'post',
    data
  })
}

// 导出根据主键查询人员统计
export function exportSummaryInfoByIdApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/exportSummaryInfoById',
    method: 'post',
    data
  })
}

// 导出根据主键查询人员明细
export function exportInfoByIdApi(data) {
  return request({
    url: 'tms-web/salaryExternalEmployeeSalaryBill/exportInfoById',
    method: 'post',
    data
  })
}